<sdc-bo-dialog
  headerTitle="Something went wrong..."
  [styleClass]="['variant-prominent-title', 'variant-danger']">
  <p>
    There was an error trying to delete event with identificator:
    {{ data()?.id }}
  </p>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="primary" (onClick)="onDismiss()">Close</sdc-button>
  </ng-container>
</sdc-bo-dialog>
